document.addEventListener('click', function (e) {
  var drawer = document.getElementById('CartDrawer');
  var wrap = document.getElementById('cartOrderNoteWrap');
  var panel = document.getElementById('cartOrderNotePanel');
  var button = document.getElementById('cartOrderNoteToggle');
  var toggle = e.target.closest('#cartOrderNoteToggle');
  var close = e.target.closest('#cartOrderNoteClose');

  if (!drawer || !wrap || !panel || !button) return;

  function openPanel() {
    panel.hidden = false;
    button.style.display = 'none';

    requestAnimationFrame(function () {
      panel.classList.add('is-open');
      drawer.classList.add('cart-note-open');
    });
  }

  function closePanel() {
    panel.classList.remove('is-open');
    drawer.classList.remove('cart-note-open');

    setTimeout(function () {
      panel.hidden = true;
      button.style.display = '';
    }, 220);
  }

  if (toggle) {
    e.preventDefault();
    if (!panel.hidden) return;
    openPanel();
    return;
  }

  if (close) {
    e.preventDefault();
    closePanel();
    return;
  }

  if (!panel.hidden && !wrap.contains(e.target)) {
    closePanel();
  }
});

document.addEventListener('keydown', function (e) {
  var drawer = document.getElementById('CartDrawer');
  var panel = document.getElementById('cartOrderNotePanel');
  var button = document.getElementById('cartOrderNoteToggle');

  if (!drawer || !panel || !button) return;

  if (e.key === 'Escape' && !panel.hidden) {
    panel.classList.remove('is-open');
    drawer.classList.remove('cart-note-open');

    setTimeout(function () {
      panel.hidden = true;
      button.style.display = '';
    }, 220);
  }
});